import { render, staticRenderFns } from "./PassengerEdit.vue?vue&type=template&id=2b8da28a"
import script from "./PassengerEdit.vue?vue&type=script&lang=ts"
export * from "./PassengerEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports